import i18n from 'i18next';
import httpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { SUPPORTED_LOCALES } from '../constants';

export const DEFAULT_I18N_NS = 'default';

export default function init(overrideBasePath?: string) {
  if (i18n.isInitialized) return Promise.resolve();

  const basePath = import.meta.env.BASE_URL;
  const normalizedBase = (overrideBasePath ?? basePath).replace(/\/$/, '');
  const loadPath = `${normalizedBase}/locales/{{lng}}/{{ns}}.json`;

  return i18n
    .use(initReactI18next)
    .use(httpBackend) // passes i18n down to react-i18next
    .init({
      backend: { loadPath },
      lng: 'en-GB',
      supportedLngs: SUPPORTED_LOCALES,
      fallbackLng: 'en-GB',
      ns: DEFAULT_I18N_NS,
      load: 'currentOnly',
      react: {
        useSuspense: false,
        transSupportBasicHtmlNodes: true,
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'b'],
      },
      interpolation: {
        escapeValue: false, // react already safes from xss
      },
    });
}
